import React from 'react'
import { IAgent } from '@obvious.tech/constellation'
import { Link } from 'react-router-dom'

import { TEntityOverride, TEntityOverrideProp, TEntityView } from 'src/types'
import { Chip } from '@material-ui/core'
import { TEntityUntagged } from '@obvious.tech/constellation/Entity'

const LinkToActivityReport = (props: {
  property: TEntityOverrideProp<TEntityView, IAgent>
  record: IAgent
  name: string
}): JSX.Element | null => {
  if (typeof props.record.passportId !== 'string') return <div></div>
  const { passportId } = props.record

  return (
    <Link to={`/authentication/api/Passport/${passportId}/AgentActivityReport`}>
      <Chip
        size='small'
        style={{
          backgroundColor: '#a6dff3',
        }}
        onClick={e => e.stopPropagation()}
        label='Reports'
      />
    </Link>
  )
}
const override = {
  title: ({ lastname, firstname }) => {
    if (typeof lastname === 'string' && lastname.length > 0) {
      return `${firstname} ${lastname}`
    }
    return firstname
  },
  extraProperties: {
    $activityReports: {
      type: 'undefined',
      readOnly: true,
      displayedName: 'Activity reports',
      displayedComponent: LinkToActivityReport,
    },
  },
  global: {
    order: [
      'id',
      'groups',
      'label',
      'passportReference',
      'passportId',
      '$activityReports',
      'lastname',
      'firstname',
      'birthDate',
      'organization',
      'service',
      'job',
      'photoId',
      'status',
      'transportMode',
      'buildingGroup',
      'layers',
      'markerId',
      'markerImageId',
      'location',
      'locationTimestamp',
      'isConnected',
      'cameraIds',
      'equipments',
      'geofencesIds',
      'missionId',
    ],
    properties: {
      id: {
        displayedName: 'ID',
      },
      label: {
        displayedName: 'Label',
      },
      firstname: {
        displayedName: 'Firstname',
      },
      lastname: {
        displayedName: 'Lastname',
      },
      organization: {
        displayedName: 'Organization',
      },
      service: {
        displayedName: 'Service',
      },
      job: {
        displayedName: 'Job',
      },
      passportId: {
        // deprecated, replaced with `passportReference`
        hidden: true,
      },
      passportReference: {
        displayedName: 'Passport',
        type: 'object',
        reference: {
          target: 'Passport',
          idKeyPath: 'passportId',
          labelKeyPath: 'userName',
          targetLabelKeyPath: 'username',
        },
      },
      cameraIds: {
        displayedName: 'Cameras',
        reference: {
          target: 'Camera',
          targetLabelKeyPath: 'name',
        },
      },
      missionId: {
        displayedName: 'Mission ID',
        reference: {
          target: 'Mission',
        },
        readOnly: false,
      },
      markerId: {
        displayedName: 'Marker ID',
        reference: {
          target: 'Marker',
        },
      },
      isConnected: {
        type: 'boolean',
        displayedName: 'Is connected ?',
        readOnly: false,
      },
      location: {
        displayedName: 'Location',
      },
      locationTimestamp: {
        displayedName: 'Location last updated',
      },
      buildingGroup: {
        displayedName: 'Building group',
      },
      photoId: {
        displayedName: 'Photo',
        reference: {
          target: 'Image',
          targetLabelKeyPath: 'name',
        },
      },
      markerImageId: {
        displayedName: 'Marker icon / Avatar',
        reference: {
          target: 'Image',
          targetLabelKeyPath: 'name',
        },
      },
      transportMode: {
        displayedName: 'Transport mode',
      },
      groups: {
        type: 'groups',
        displayedName: 'Owners',
      },
      geofencesIds: {
        displayedName: 'Geofences',
        reference: {
          target: 'Geofence',
          targetLabelKeyPath: 'name',
        },
      },
      birthDate: {
        displayedName: 'Birth date',
        type: 'date-time',
      },
      layers: {
        displayedName: 'Layers/Filters',
      },
      status: {
        displayedName: 'Status',
        reference: {
          target: 'AgentStatus',
          targetLabelKeyPath: 'name',
        },
      },
      equipments: {
        displayedName: 'Equipments',
      },
    },
  },
  create: {
    properties: {
      isConnected: {
        hidden: true,
      },
    },
  },
  edit: {
    properties: {
      isConnected: {
        readOnly: false,
      },
    },
  },
  list: {
    properties: {
      markerId: {
        hidden: true,
      },
      location: {
        hidden: true,
      },
      cameraIds: {
        hidden: true,
      },
      missionId: {
        hidden: true,
      },
      photoId: {
        hidden: true,
      },
      markerImageId: {
        hidden: true,
      },
    },
  },
} satisfies TEntityOverride<TEntityUntagged<'Agent'>, '$activityReports'>

export default override
